// SPDX-License-Identifier: MIT
// Shared accessor for the global Tauri `invoke` (tauri.conf.json
// withGlobalTauri:true). Kept in one place so every desktop-only module (the AI
// bridge, the provider-store) resolves it identically, and the shared frontend
// NEVER statically imports @tauri-apps — the web build stays clean.
export type Invoke = (cmd: string, args?: Record<string, unknown>) => Promise<unknown>;

export function tauriInvoke(): Invoke {
  const w = window as unknown as { __TAURI__?: { core?: { invoke?: Invoke } } };
  const inv = w.__TAURI__?.core?.invoke;
  if (!inv) throw new Error('[desktop] Tauri invoke unavailable (withGlobalTauri off, or not running in the desktop shell)');
  return inv;
}

// Tauri 2 ipc Channel — the streaming primitive. A #[tauri::command] takes a
// Channel<T> arg and `send`s many messages across one invoke. With withGlobalTauri
// it's exposed at window.__TAURI__.core.Channel. We type only the surface we use
// (set onmessage, pass the instance as a command arg).
export interface TauriChannel<T> { onmessage: ((message: T) => void) | null; }
type ChannelCtor = new <T>() => TauriChannel<T>;

export function tauriChannelCtor(): ChannelCtor {
  const w = window as unknown as { __TAURI__?: { core?: { Channel?: ChannelCtor } } };
  const C = w.__TAURI__?.core?.Channel;
  if (!C) throw new Error('[desktop] Tauri Channel unavailable (withGlobalTauri off, or not in the desktop shell)');
  return C;
}
